import { useState } from 'react';
import { Box, Button } from "@mui/material";
import React from "react";
// import './sasaveDraft/saveDraft.scss';
const CreateTL = ({ setActiveTab, draft, setDraft }) => {
  const [enName, setEnName] = useState(draft?.name || '');
  const [faName, setFaName] = useState(draft?.persianTimelineTitle || '');
  const [faAlert, setFaAlert] = useState(null);
  const [enAlert, setEnAlert] = useState(null);

  const handleSubmit = () => {
    const draftEnName = enName.trim();
    const draftFaName = faName.trim();
    if(!draftEnName.length){
      setEnAlert('Enter a name for your Timeline');
      return
    }
    if(!draftFaName.length){
      setFaAlert('Enter a name for your Timeline');
      return
    }
    const newDraft = {
      ...draft,
      persianTimelineTitle: draftFaName,
      title: draftEnName,
    }
    setDraft(newDraft);
    setActiveTab('artistName');
  };

  const handleChangeFaName = (e) => {
    setFaAlert(null);
    setFaName(e.target.value);
  };

  const handleChangeEnName = (e) => {
    setEnAlert(null);
    setEnName(e.target.value);
  };

  return (
    <>
      <Box
        style={{
          width: "100%",
          height: "78%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        <div
          className="custom-input-container"
          style={{ height: "30%", width: "100%", marginTop: "10%" }}
        >
          <label className="custom-input-label">TimeLine name Eng</label>
          <input
            type="text"
            placeholder="TIMELINE"
            className={`custom-input ${enAlert? 'error' : ''}`}
            style={{ height: "100%" }}
            value={enName}
            onChange={handleChangeEnName}
          />
           {enAlert && <div className="alert">{enAlert}</div>}
        </div>
        <div
          className="custom-input-container"
          style={{ height: "30%", width: "100%", marginBottom: "10%" }}
        >
          <label className="custom-input-label">TimeLine name Fa</label>
          <input
            type="text"
            placeholder="تایم لاین"
            className={`custom-input ${faAlert? 'error' : ''}`}
            style={{
              height: "100%",
              direction: "rtl",
              fontFamily: "Dastnevis",
            }}
            value={faName}
            onChange={handleChangeFaName}
          />
          {faAlert && <div className="alert">{faAlert}</div>}
        </div>
      </Box>
      <Button
        className="button-save"
        onClick={handleSubmit}
      >
        Next
      </Button>
    </>
  );
};

export default CreateTL;
